import i18n from 'i18next';
import Backend from 'i18next-chained-backend';
import Http from 'i18next-http-backend';
import LocalforageBackend from 'i18next-localforage-backend'; // primary use cache
import localforage from 'localforage';
import { initReactI18next } from 'react-i18next';
import BackendAdapter from 'i18next-multiload-backend-adapter';
import authService from '../authentication/AuthorizeService';
import config from './Config';
import getLogger from '../utils/logger';

authService
  .getUser()
  .then((user) => {
    if (user) {
      i18n
        // load translation using http -> see /public/locales
        // learn more: https://github.com/i18next/i18next-http-backend
        // pass the i18n instance to react-i18next.
        .use(Backend)
        .use(initReactI18next) // passes i18n down to react-i18next
        // init i18next
        // for all options read: https://www.i18next.com/overview/configuration-options
        .init({
          fallbackLng: 'en-US',
          debug: false,
          ns: [
            'TRANSLATIONS_RCORE_TOPNAV',
            'TRANSLATIONS_RCORE_TOPNAV_SEARCH',
            'TRANSLATIONS_RCORE_COMMON'
          ],
          defaultNS: 'TRANSLATIONS_RCORE_TOPNAV',
          lng: user && user.profile && user.profile.culture, // this needs to change as per user locale so the translations are saved in indexeddb with proper key for e.g. en-US_TRANSLATIONS_PORTAL
          // interpolation: {
          //   escapeValue: false, // not needed for react as it escapes by default
          // },
          backend: {
            backends: [
              LocalforageBackend, // primary
              new BackendAdapter(null, {
                backend: new Http(null, {
                  // // loadPath: "http://ayjain11in.amr.smtf.ds/services/api/i18n/react?keys={{ns}}",
                  loadPath: `${config.domain}services/api/i18n/react?ns={{ns}}`,
                  customHeaders: {
                    Authorization: `Bearer ${user && user.access_token}`
                  },
                  allowMultiLoading: false
                })
              })
            ],
            backendOptions: [
              {
                // set expiration to 1 day
                expirationTime: 1 * 24 * 60 * 60 * 1000,

                /**
                 * Localforage specific options
                 */
                // database name (prefix is using localStorage as storage driver)
                name: 'ST',

                // The driver(s) to use, if multiple are provided, the first available is used
                driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],

                // when using IndexedDb is the dataStore name, when using WebSQL is the table name
                storeName: 'rcore',

                // description of the database, for developer usage
                description: ''
              },
              {}
            ]
          },
          react: {
            useSuspense: true
          }
        });
    }
    return null;
  })
  .catch((error) => {
    getLogger().error('Error in fetching translations', error);
  });
